import'./App.css';

import 'animate.css';
import Navs from './comp/Nave';
import Footer from './comp/Footer';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Home from './comp/home content/Home';
import { Route, Routes} from 'react-router-dom';
import Developers from './comp/home content/Developers/Developers';
import About from './comp/home content/about/About';
import { useEffect, useState } from 'react';
import HashLoader from "react-spinners/HashLoader";
// import Page1 from './comp/home content/Developers/pages/Page1';
// import Page2 from './comp/home content/Developers/pages/Page2';
// import Page4 from './comp/home content/Developers/pages/Page4';
// import Page5 from './comp/home content/Developers/pages/Page5';
// import Page6 from './comp/home content/Developers/pages/Page6';
// import Page7 from './comp/home content/Developers/pages/Page7';
// import Data from './comp/Details';
import Details from './comp/Details';
function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() =>{
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    },2000)
  },[])
  return (
    <div className='App'>
      {
        loading?
        <div style={{display:'flex' , justifyContent:'center',alignItems:'center',height:'100%'} }>
          <HashLoader
          color={'#0d4d8f'}
          loading={loading}
          size={150}
        />
        </div>
      :
      <>      
      <Navs />
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='Developers' element={<Developers />}></Route>
          <Route path='about' element={<About />}></Route>
          <Route path="product/:productId" element={<Details />}></Route>
        </Routes>
      <Footer />
      </>
      }
    </div>
  );
}

export default App;
